import { z } from 'zod';
export const baseGenitourinary = z.object({
    wnl: z.boolean().optional(),
    status: z.array(z.string()).optional(),
    genitourinaryCatheter: z.string().optional(),
    genitourinaryFrSize: z.string().optional(),
    genitourinaryBalloonSize: z.string().optional(),
    genitourinaryAction: z.string().optional(),
    genitourinaryActionDate: z.string().optional(),
    genitourinaryOdor: z.string().optional(),
    urineColor: z.string().optional(),
});
export const baseGenitourinaryRefined = baseGenitourinary.refine((data) => data.wnl ||
    data.status?.length ||
    data.genitourinaryCatheter ||
    data.genitourinaryFrSize ||
    data.genitourinaryBalloonSize ||
    data.genitourinaryAction ||
    data.genitourinaryActionDate ||
    data.genitourinaryOdor ||
    data.urineColor, {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
export const baseGastrointestinal = z.object({
    wnl: z.boolean().optional(),
    status: z.array(z.string()).optional(),
    gastrointestinalLastBowel: z.string().optional(),
    gastrointestinalLastBowelType: z.string().optional(),
    vomittingAmount: z.string().optional(),
    diarrheaAmount: z.string().optional(),
    abdomenGirth: z.string().optional(),
    abdomenStatus: z.array(z.string()).optional(),
    gastrointestinalLuqPain: z.string().optional(),
    gastrointestinalLlqPain: z.string().optional(),
    gastrointestinalRuzPain: z.string().optional(),
    gastrointestinalRlqPain: z.string().optional(),
    gastrointestinalAppetiteStatus: z.string().optional(),
    gastrointestinalAppetiteEnteralFeeding: z.string().optional(),
    gastrointestinalAppetiteEnteralFeedingVia: z.string().optional(),
    gastrointestinalAppetiteFdgRate: z.string().optional(),
    gastrointestinalAppetiteFdgResidual: z.string().optional(),
    gastrointestinalAppetiteOstomy: z.boolean().optional(),
    gastrointestinalAppetiteOstomyLocation: z.string().optional(),
    gastrointestinalAppetiteOstomyStatus: z.string().optional(),
    gastrointestinalAppetiteOstomyDrainageAmt: z.string().optional(),
});
export const baseGastrointestinalRefined = baseGastrointestinal.refine((data) => data.wnl ||
    data.status?.length ||
    data.gastrointestinalLastBowel ||
    data.gastrointestinalLastBowelType ||
    data.vomittingAmount ||
    data.diarrheaAmount ||
    data.abdomenGirth ||
    data.abdomenStatus?.length ||
    data.gastrointestinalLuqPain ||
    data.gastrointestinalRuzPain ||
    data.gastrointestinalLlqPain ||
    data.gastrointestinalRlqPain ||
    data.gastrointestinalAppetiteStatus ||
    data.gastrointestinalAppetiteEnteralFeeding ||
    data.gastrointestinalAppetiteEnteralFeedingVia ||
    data.gastrointestinalAppetiteFdgRate ||
    data.gastrointestinalAppetiteFdgResidual ||
    data.gastrointestinalAppetiteOstomy ||
    data.gastrointestinalAppetiteOstomyLocation ||
    data.gastrointestinalAppetiteOstomyStatus ||
    data.gastrointestinalAppetiteOstomyDrainageAmt, {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
export const SectionH = {
    m1600: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    m1610: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    genitourinary: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    m1620: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    m1630: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    gastrointestinal: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
// H-M1600_UTI-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Patient on prophylactic treatment"},{"value":"UK","label":"Unknown"}]
// H-M1610_UR_INCONT-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No incontinence or catheter (includes anuria or ostomy for urinary drainage)"},{"value":"01","label":"Patient is incontinent"},{"value":"02","label":"Patient requires a urinary catheter (specifically: external, indwelling, intermittent, suprapubic)"}]
// H-M1620_BWL_INCONT-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Very rarely or never has bowel incontinence"},{"value":"01","label":"Less than once weekly"},{"value":"02","label":"One to three times weekly"},{"value":"03","label":"Four to six times weekly"},{"value":"05","label":"More often than once daily"},{"value":"NA","label":"Patient has ostomy for bowel elimination"},{"value":"UK","label":"Unknown"},{"value":"04","label":"On a daily basis"}]
// H-M1630_OSTOMY-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Patient does not have an ostomy for bowel elimination."},{"value":"01","label":"Patient's ostomy was not related to an inpatient stay and did not necessitate change in medical or treatment regimen."},{"value":"02","label":"The ostomy was related to an inpatient stay or did necessitate change in medical or treatment regimen."}]
